import React from 'react';
import { Link } from 'react-router-dom';
import './LogoHeader.scss';
import LogoExtraBit from '../../images/logo-extra-bit.png';

function LogoHeader() {
  return (
    <section className="sct-start">
      <header className="App-header">
        <div className="header-logo">
          <div className="container">
            <Link to="/">
              <img
                src={LogoExtraBit}
                alt="Extra Franchising"
                className="u-center-center img-fluid"
              />
            </Link>
          </div>
        </div>
      </header>
    </section>
  );
}

export default LogoHeader;
